<template>
  <div class="container">
    <div class="terms__message">
      <z-title
        class="terms-policy__title"
        size="medium"
        tag="h1"
      >
        TERMOS E CONDIÇÕES DE USO
      </z-title>

      <z-text
        tag="p"
        align="left"
      >
        Última atualização em 02 de Janeiro de 2023
      </z-text>

      <z-text
        tag="p"
        align="left"
      >
        Estes Termos e Condições de Uso (“Termos”), juntamente com a <a target="blank"
                                                                        href="/privacidade"
        >Política de Privacidade</a>,
        aplicam-se a todas as plataformas da QUERO EDUCAÇÃO SERVIÇOS DE
        INTERNET LTDA., empresa inscrita no CNPJ sob o n. 10.542.212/0001-54, com sede na Avenida Nove de Julho, n. 765,
        sala 31, Jardim Apolo, São José dos Campos/SP, CEP: 12243-000. <strong>Leia-os com atenção.</strong>
      </z-text>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        1. ACEITE DOS TERMOS E CONDIÇÕES DE USO
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          1.1. Ao utilizar qualquer plataforma do QUERO PAGO (“Plataforma”), o Usuário manifesta, de forma livre e
          expressa, sua concordância e observância a estes Termos e à Política de Privacidade.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          1.2. Algumas áreas da Plataforma exigem o <strong>cadastro</strong> do Usuário no site para que possam
          ser acessadas, oportunidade na qual o QUERO PAGO irá requisitarao Usuário que crie um login, composto
          por e-mail e senha e informe dados pessoais.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          1.3. Ao cadastrar-se na Plataforma, o Usuário:
        </z-text>

        <div class="container">
          <z-text
            tag="p"
            align="left"
          >
            a) Garante ser plenamente capaz de contratar os serviços do QUERO PAGO ou estar devidamente autorizado
            pelos seus responsáveis legais;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            b) Entende que responde pela veracidade, exatidão, autenticidade e atualização dos dados pessoais
            cadastrados;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            c) Entende que o login de acesso é pessoal e intransferível, sendo responsável por sua guarda e
            conservação;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            d) Tem ciência e concorda que, ao concluir o cadastro, o Usuário, por meio do aceite destes Termos,
            seus dados pessoais poderão ser compartilhados com instituições de ensino parceiras para o
            desenvolvimento do relacionamento e comunicação, bem como demais medidas que se façam necessárias
            para a prestação de serviços educacionais relacionados ao objeto social do QUERO PAGO e/ou instituição
            de ensino parceira; e
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            e) Confirma ter lido, compreendido e aceitado a Política de Privacidade, onde informamos como coletamos e
            utilizamos seus dados pessoais.
          </z-text>
        </div>

        <z-text
          tag="p"
          align="left"
        >
          1.4. O QUERO PAGO se reserva o direito de, a seu exclusivo critério, cancelar ou suspender a conta do Usuário
          como medida de proteção à Plataforma, aos outros Usuários e instituição de ensino parceiras, caso tenha
          indícios de furto ou roubo de identidade, fraude de documentos, utilização e/ou apropriação de meios de
          pagamento de forma ilícita e/ou qualquer outro indício de atividades fraudulentas, não sendo cabível
          qualquer tipo de responsabilização da QUERO pelo cancelamento ou suspensão do referido Usuário
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          1.5. O Usuário deve notificar, o QUERO PAGO imediatamente sobre qualquer uso não autorizado de sua conta ou
          na ocorrência de qualquer outra violação de segurança.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          1.6. Ao aceitar estes Termos, o Usuário aceita que o QUERO PAGO e/ou a instituição de ensino parceira poderá
          contatá-lo por todos os meios de comunicação disponíveis em seu cadastro, incluindo, mas não se limitando a
          carta, e-mail, ligações telefônicas, mensagens de texto, imagem no telefone celular, softwares de mensagens
          instantâneas tais como Whatsapp, Telegram, Facebook Messenger, Skype, etc.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          1.7. A equipe do QUERO PAGO está à disposição para esclarecer quaisquer pontos que eventualmente não foram
          compreendidos pelo Usuário ao longo da leitura destes Termos. Se, porém, após o esclarecimento de qualquer
          dúvida com a equipe do QUERO PAGO, o Usuário não concorde com qualquer das condições aqui descritas,
          orientamos a não usar os serviços ofertados.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          1.8. Por favor, note que, para o Usuário utilizar as Plataformas, este terá que concordar que o QUERO PAGO
          tenha acesso aos seus dados pessoais. Consulte nossa Política de Privacidade para entender quais são os
          dados coletados e como serão usados. Se você não concorda com nossa Política de Privacidade, você não deve
          inserir seus dados pessoais nas Plataformas.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        2. CONDUTA DO USUÁRIO
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          2.1. O Usuário não poderá enviar, via Plataforma, qualquer conteúdo que:
        </z-text>

        <div class="container">
          <z-text
            tag="p"
            align="left"
          >
            a) seja ameaçador, obsceno, imoral, antiético, indecente, ofensivo, pornográfico, abusivo, odioso,
            discriminatório de qualquer natureza, escandaloso, inflamatório, confidencial, privado, ou de
            qualquer natureza não adequado ou não alinhado aos propósitos dos serviços prestados pelo QUERO PAGO;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            b) se constitua de ou encoraje atitudes consideradas ofensas criminosas, dê origem a responsabilidade
            civil, de alguma maneira seja contrário às leis vigentes ou infrinja os direitos de terceiros; e
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            c) seja tecnicamente danoso (incluindo, mas não limitado a vírus de computador, bombas lógicas, cavalos
            de Tróia, vírus tipo worm, injeção de SQL, componentes danosos, dados corrompidos ou qualquer outro
            software malicioso).
          </z-text>
        </div>

        <z-text
          tag="p"
          align="left"
        >
          2.2. É vedado ao Usuário utilizar a Plataforma de forma imprópria incluindo, mas não limitado a quaisquer
          ações classificadas como hacking ou cracking.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        3. PAGAMENTOS VIA PLATAFORMA
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          3.1. Os pagamentos das mensalidades, taxas e demais valores eventualmente devidos à Instituição de Ensino
          deverão ser pagos através da Plataforma.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.2. Os comprovantes dos pagamentos realizados via QUERO PAGO (ou qualquer outro produto que venha a
          substituí-lo para pagamentos realizados na Plataforma),serão válidos para comprovação de quitação dos
          débitos do Usuário junto à respectiva Instituição de Ensino.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.3. O Usuário poderá verificar, via Plataforma Quero Pago, (a) os valores pagos e; (b) os valores
          inadimplidos.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.4. Em caso de inadimplemento, o Usuário reconhece e concorda que o QUERO PAGO proceda cobranças em nome
          da respectiva Instituição de Ensino incluindo, mas não se limitando ao envio de cobranças e notificações
          via carta, e-mail, ligações telefônicas, mensagens de texto, imagem no telefone celular, softwares de
          mensagens instantâneas tais como Whatsapp, Telegram, Facebook Messenger, Skype, etc.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.5. O Usuário reconhece que, em caso de inadimplemento, estará sujeito à inclusão de seus dados nos
          cadastros de proteção de crédito disponíveis no Brasil, incluindo, mas não se limitando ao Serasa,
          SPC e SCPC, bem como ao protesto dos títulos inadimplidos em cartório de protestos.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.6. Caso o Usuário não concorde com qualquer valor cobrado pelo QUERO PAGO em nome da Instituição
          de Ensino, o Usuário deverá, imediatamente, entrar em contato com o QUERO PAGO, por meio dos canais
          disponíveis na Plataforma, e realizar uma reclamação fundamentada, instruindo com documentos
          comprobatórios.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.7. O QUERO PAGO terá um prazo de 30 (trinta) dias corridos para analisar a reclamação do Usuário e
          concluir pela procedência ou não da reclamação.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.8. Caso o QUERO PAGO conclua pela procedência da reclamação, cessará a cobrança em um prazo de até 5
          (cinco) dias úteis.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.9. Caso o QUERO PAGO conclua pela improcedência da reclamação, não cessará as cobranças e o reembolso
          não será realizado.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.10. Os valores devidos pelo usuário deverão ser pagos por meio do serviço de pagamento online oferecido
          por empresa especializada.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          3.11. O processamento das informações de pagamento e a confirmação do pagamento serão de responsabilidade
          da respectiva empresa de gestão de pagamentos online.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        4. PROPRIEDADE INTELECTUAL
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          4.1. Todos os materiais disponibilizados na Plataforma, incluindo, mas não se limitando a arquivos,
          provas, áudios, sons, marcas, logomarcas, materiais publicitários, dentre outros, são de propriedade
          exclusiva do QUERO PAGO, ou de terceiros que concederam ao QUERO PAGO autorização para tal utilização,
          estando protegidos, portanto, pelas leis e tratados internacionais. Razão pela qual, o QUERO PAGO detém
          com exclusividade todos os direitos, titularidade e interesses em todos os elementos os quais recaem
          direitos de propriedade intelectual, incluindo, mas não se limitando, a aparência, características e a
          infraestrutura da Plataforma na qual o serviço é disponibilizado.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          4.2. É vedado ao Usuário copiar, vender, revender, exibir, reproduzir, publicar, modificar, criar,
          transferir, distribuir ou de outro modo explorar comercialmente qualquer conteúdo disponibilizado na
          Plataforma sem o prévio consentimento devidamente formalizado por escrito do QUERO PAGO ou dos
          licenciadores do respectivo conteúdo.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          4.3. O Usuário deve estar ciente de que qualquer utilização indevida do material disponibilizado
          na Plataforma poderá representar, além da violação de direitos de propriedade intelectual do QUERO PAGO,
          violação dos direitos da Instituição de Ensino e/ou de terceiros, sendo de responsabilidade exclusiva do
          Usuário qualquer reparação de danos e despesas incorridas nesse sentido pelo QUERO PAGO, instituições de
          ensino e/ou por quaisquer terceiros.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        5. LIMITAÇÕES DE RESPONSABILIDADE
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          5.1. O time de tecnologia do QUERO PAGO se dedica intensamente, alocando os recursos possíveis e viáveis,
          para manter a Plataforma em pleno funcionamento para todos os Usuários. No entanto, o QUERO PAGO e seus
          funcionários, diretores, sócios e representantes não poderão ser responsabilizados, em nenhuma
          circunstância, por eventual dificuldade de acesso à Plataforma, por eventuais interrupções temporárias
          decorrentes de dificuldades técnicas ou de manutenção, ou por outras razões quaisquer que escapem do
          controle do time de tecnologia do QUERO PAGO, bem como por quaisquer danos, prejuízos ou perdas, de
          qualquer forma causados ao Usuário por falhas na internet e por quaisquer vírus, cavalos de Tróia, worms
          ou outras rotinas de programação de computador que possam danificar, interferir adversamente ou possam
          ser infiltrados nos equipamentos do Usuário em decorrência do acesso à Plataforma ou como consequência
          da transferência de dados, arquivos, imagens, textos ou qualquer outro conteúdo contidos nos computadores,
          aparelhos e/ou dispositivos utilizados pelo Usuário para acessar a Plataforma.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          5.2. O QUERO PAGO não se responsabiliza por informações incorretas, incompletas ou inverídicas, ou
          documentos falsos fornecidos pelo Usuários no formulário de cadastro ou submetido de qualquer
          forma ao QUERO PAGO e eventualmente repassados às instituições de ensino, bem como não se responsabiliza
          por eventuais danos gerados ao Usuário, às instituições de ensino e/ou a terceiros em consequência da
          imprecisão ou falsidade dessas informações fornecidas pelos Usuários.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          5.3. O QUERO PAGO não será responsável:
        </z-text>

        <div class="container">
          <z-text
            tag="p"
            align="left"
          >
            a) pelos atos praticados e/ou danos causados à Instituição de Ensino pelo Usuário;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            b) pelos atos praticados e/ou danos causados pela Instituição de Ensino ao Usuário.
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            c) por qualquer dano direto, indireto, material, moral, emergente, lucros cessantes que
            não tenha sido causado exclusiva e diretamente pelo Quero Pago;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            d) por qualquer falha, fraude ou omissão cometida pela Instituição de Ensino na análise dos documentos
            pessoais (próprios ou dos representantes legais, caso o Usuário seja menor de 18 anos) fornecidos pelos
            Usuários ao realizar a matrícula em cursos contratados através da Plataforma;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            e) pela política de preços praticada pela Instituição de Ensino em relação aos seus cursos;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            f) caso a Instituição de Ensino altere, por conta própria, os termos e condições de uma
            Bolsa ofertada e/ou contratada;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            g) caso a Instituição de Ensino negue, a seu exclusivo critério, a matrícula do Usuário
            que houver cumprido todos os requisitos estabelecidos nestes Termos;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            h) pela não formação de turma e/ou suspensão de qualquer curso cujo Usuário tenha
            manifestado interesse em realizar;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            i) por qualquer alteração de cronograma dos cursos das instituições de ensino veiculados
            no âmbito do Quero Pago;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            j) por qualquer falha no planejamento e prestação dos serviços de ensino, designação de professores,
            orientação didática, fixação de currículo e qualquer outra providência necessária à prestação dos
            serviços educacionais pela Instituição de Ensino aos seus alunos;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            k) por eventuais interrupções temporárias decorrentes de dificuldades técnicas ou de manutenção de
            sistema, bem como por quaisquer danos, prejuízos ou perdas, de qualquer forma causados ao Usuário
            por falhas do QUERO PAGO, da internet e por quaisquer vírus, cavalos de tróia, worms ou outras
            rotinas de programação que possam danificar, interferir adversamente ou possam ser infiltrados
            nos equipamentos do Usuário em decorrência do acesso à Plataforma do Quero Pago;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            l) por quaisquer prejuízos resultantes de acessos não autorizados ou uso da conta do Usuário por
            terceiros;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            m) por conteúdos inseridos por um Usuário na Plataforma;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            n) pelo conteúdo ou práticas de quaisquer sites de terceiros cujos links ou propaganda sejam
            eventualmente disponibilizados na Plataforma;
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            o) por cobranças indevidas ou errôneas em virtude das informações recebidas da Instituição
            de Ensino; e
          </z-text>

          <z-text
            tag="p"
            align="left"
          >
            p) em caso de falência e/ou recuperação judicial da Instituição de Ensino, quando a Instituição de Ensino
            será a única responsável pelos danos e/ou defeitos na prestação dos serviços educacionais eventualmente
            causados aos alunos.
          </z-text>
        </div>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        6. PROTEÇÃO DE DADOS PESSOAIS
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          6.1. Os dados pessoais fornecidos à QUERO pelo Usuário serão tratados da forma prevista na Política de
          Privacidade que é parte integrante destes Termos.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        7. CESSÃO
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          7.1. O Usuário não poderá ceder e, de nenhuma forma, transferir, total ou parcialmente, os direitos e
          obrigações constantes destes Termos sem o prévio consentimento por escrito da QUERO. A QUERO poderá
          transferir os direitos e obrigações decorrentes destes Termos, sem qualquer necessidade de notificação
          ou permissão dos Usuários, em casos de venda parcial ou total dos seus ativos, alteração de controle,
          reestruturação societária e outras formas de fusão, cisão ou incorporação.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        8. RESOLUÇÃO DE CONTROVÉRSIAS
      </z-title>

      <div class="container">
        <z-text
          color="minor"
          tag="p"
          align="left"
        >
          8.1. Fica eleito o foro do domicílio do Usuário como o único competente para dirimir eventuais controvérsias
          referentes à interpretação e ao cumprimento destes Termos. No entanto, antes de recorrer para via Judicial,
          o Quero Pago incentiva o Usuário a contatar o QUERO PAGO através dos Canais de Atendimento para resolver, de
          forma amigável, toda e qualquer dificuldade e/ou problema que o Usuário possa estar eventualmente enfrentando
          em relação aos serviços contratados.
        </z-text>
      </div>

      <z-title
        class="terms-policy__title"
        tag="h2"
      >
        CANAIS DE ATENDIMENTO
      </z-title>

      <div class="container">
        <z-text
          tag="p"
          align="left"
        >
          Nossos Canais de Atendimento poderão ser utilizados pelo Usuário para fazer reclamações, comunicações, pedir
          esclarecimentos e providências, requisitar seus Dados Pessoais, dentre outros. O Usuário poderá entrar em
          contato através dos Canais de Atendimento, conforme descrito nestes Termos, ou ainda, através da conta do
          Usuário, ao clicar em 'Dúvidas? Fale com a gente'.
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          Nossos Canal de atendimento é:
        </z-text>

        <z-text
          tag="p"
          align="left"
        >
          Whatsapp: 0800 291 7878(horário comercial);
        </z-text>
      </div>
    </div>
  </div>
</template>

<script>
import { ZText, ZTitle } from '@quero/zilla-vue';

export default {
  components: {
    ZText,
    ZTitle,
  },
};
</script>

<style lang="scss" scoped>
.terms__message {
  padding: var(--size-jumbo) 0;
  & .z-title,
  & .z-text {
    padding: var(--size-small) 0;
  }
}
</style>
